import { FC, memo } from 'react'

import { Form } from 'brief-form'
import { Select } from 'ui/components'
import { FilterPanel } from 'ui/components/Table'

import { FilterProps } from './filterProps'

import { FormBox, TypeWrapper } from './styles'

export const Filter: FC<FilterProps> = memo((props) => {
  const {
    form: { config, isDirty, Field },
    expanded,
    onToggle,
    contactsTypeOptions,
    onClear
  } = props

  return (
    <FilterPanel isDirty={isDirty} onReset={onClear} expanded={expanded} onToggle={onToggle}>
      <Form config={config}>
        <FormBox>
          <TypeWrapper>
            <Field
              name="contactsType"
              label="Type"
              input={Select}
              inputProps={{
                data: contactsTypeOptions
              }}
            />
          </TypeWrapper>
        </FormBox>
      </Form>
    </FilterPanel>
  )
})
